import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { MaintenanceAPI } from "../../../apis/MaintenanceAPI";
import { NavLink } from "react-router-dom";
import isLoggedIn from "../../../utils/isLoggedIn";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import userContext from "../../../context/userContext";
import MaintenancesList from "./MaintenancesList"

const DeleteContract = () => {
    const navigate = useNavigate();

    const { userLoggedIn } = useContext(userContext);
    const [isLoading, setIsLoading] = useState(true)
    const [apiErr, setApiErr] = useState()
    const [companies, setCompanies] = useState();
    const [contracts, setContracts] = useState();
    const [selectedContract, setSelectedContract] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false)


    const getData =  () => {
         MaintenanceAPI.getCompaniesWithContract().then(function (res) {
            setCompanies(res.data);
            setIsLoading(false)
            console.log(res.data)
        }).catch(function (err) {
            if (err.response.status === 401 || err.response.status === 403) {
                navigate("/profil");
            } else {
                setIsLoading(false)
                setApiErr("Une erreur est survenue")
            }
        });
    }

    const displaySecondDropdown = (e) => {
        let selectedCompany = companies.find(el => el.id == e.target.value)
        setContracts(selectedCompany.maintenanceContracts);
        setSelectedContract("")
    }


    const deleteContract = async () => {
        setIsSubmitting(true)
        await MaintenanceAPI.deleteContract(selectedContract).then(
            function () {
                navigate("/maintenances")
            }
        ).catch(function () {
            setApiErr("Une erreur est survenue")
        });
    }

    useEffect(
        () => {
            document.title = "Devolie - Les maintenances"
            if (userLoggedIn.roles[0] !== "ROLE_ADMIN") navigate("/profil");

            if (!isLoggedIn()) {
                navigate("/");
            } else {
                getData();
            }
        },
        []
    );

    return (
        <div>
            <div className="header-with-cta">
                <h1>Les maintenances</h1>
            </div>
            {isLoading && (
                <p className="loading">Chargement...</p>
            )}
            {apiErr && !companies && (
                <p className="api-err">Une erreur est survenue.</p>
            )}

            {!isLoading && companies && (
                <main>
                    <div className="maintenances-header-select">
                        <div className="">
                            <select onChange={displaySecondDropdown}>
                                <option selected={true} value="" disabled>Client</option>
                                {
                                    companies.map(company => <option value={company.id} key={company.id + company.companyName} >{company.companyName}</option>)
                                }
                            </select>

                        </div>

                        {
                            contracts && (
                                <div>
                                    <select onChange={e => setSelectedContract(e.target.value)} value={selectedContract}>
                                        <option selected={true} value="" disabled>Contrat</option>
                                        {
                                            contracts.map(contract => <option value={contract.id} key={contract.id + contract.dateStart} >Contrat {new Date(contract.dateStart).getMonth() + "/" + new Date(contract.dateStart).getFullYear()}</option>)
                                        }
                                    </select>
                                </div>
                            )
                        }
                    </div>

                    <button onClick={deleteContract} disabled={isSubmitting} className="btn btn-delete"> {(isSubmitting && ("Suppression...")) || ("Supprimer")}</button>
                </main>
            )}

        </div>

    );
};

export default DeleteContract;